import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer-main">
      {/* Footer Container */}
      <div className="site-footer-container">
        {/* Brand Section */}
        <div className="site-footer-section site-footer-brand-area">
          <div className="site-footer-logo-wrapper">
            <i className="fas fa-cube"></i>
            <span className="site-footer-logo-text">AR-Bazaar</span>
          </div>
          <p className="site-footer-brand-tagline">
            The Future of Shopping with Augmented Reality Technology
          </p>

          <div className="site-footer-feature-badges">
            <div className="site-footer-feature-item">
              <i className="fas fa-check-circle"></i>
              <span>AI Powered</span>
            </div>
            <div className="site-footer-feature-item">
              <i className="fas fa-check-circle"></i>
              <span>Blockchain Verified</span>
            </div>
            <div className="site-footer-feature-item">
              <i className="fas fa-check-circle"></i>
              <span>AR Experience</span>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="site-footer-social-media">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <i className="fab fa-github"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="site-footer-section">
          <h3 className="site-footer-section-heading">
            <i className="fas fa-link"></i>
            Quick Links
          </h3>
          <ul className="site-footer-menu-list">
            <li><Link to="/"><i className="fas fa-chevron-right"></i>Home</Link></li>
            <li><Link to="/about"><i className="fas fa-chevron-right"></i>About Us</Link></li>
            <li><Link to="/ar-search"><i className="fas fa-chevron-right"></i>AR Search</Link></li>
            <li><Link to="/visual-search"><i className="fas fa-chevron-right"></i>Visual Search</Link></li>
            <li><Link to="/wishlist"><i className="fas fa-chevron-right"></i>Wishlist</Link></li>
            <li><Link to="/compare"><i className="fas fa-chevron-right"></i>Compare</Link></li>
          </ul>
        </div>

        {/* Resources */}
        <div className="site-footer-section">
          <h3 className="site-footer-section-heading">
            <i className="fas fa-book"></i>
            Resources
          </h3>
          <ul className="site-footer-menu-list">
            <li><Link to="/products"><i className="fas fa-chevron-right"></i>Compare Products</Link></li>
            <li><Link to="/guide"><i className="fas fa-chevron-right"></i>Buyers Guide</Link></li>
            <li><Link to="/blog"><i className="fas fa-chevron-right"></i>Blog</Link></li>
            <li><Link to="/help"><i className="fas fa-chevron-right"></i>Help Center</Link></li>
            <li><Link to="/faq"><i className="fas fa-chevron-right"></i>FAQ</Link></li>
          </ul>
        </div>

        {/* Support */}
        <div className="site-footer-section">
          <h3 className="site-footer-section-heading">
            <i className="fas fa-headset"></i>
            Support
          </h3>
          <ul className="site-footer-menu-list">
            <li><Link to="/contact"><i className="fas fa-chevron-right"></i>Contact Us</Link></li>
            <li><Link to="/shipping"><i className="fas fa-chevron-right"></i>Shipping Info</Link></li>
            <li><Link to="/returns"><i className="fas fa-chevron-right"></i>Returns & Refunds</Link></li>
            <li><Link to="/privacy"><i className="fas fa-chevron-right"></i>Privacy Policy</Link></li>
            <li><Link to="/terms"><i className="fas fa-chevron-right"></i>Terms of Service</Link></li>
          </ul>
        </div>

        {/* Newsletter */}
        <div className="site-footer-section site-footer-subscribe-area">
          <h3 className="site-footer-section-heading">
            <i className="fas fa-envelope"></i>
            Stay Updated
          </h3>
          <p className="site-footer-subscribe-text">
            Subscribe to get special offers, free giveaways, and AR shopping tips!
          </p>

          <form className="site-footer-subscribe-form" onSubmit={handleSubscribe}>
            <div className="site-footer-input-group">
              <i className="fas fa-envelope site-footer-input-icon"></i>
              <input
                type="email"
                className="site-footer-email-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="site-footer-subscribe-button">
              <i className="fas fa-paper-plane"></i>
              Subscribe
            </button>
          </form>

          {subscribed && (
            <div className="site-footer-subscribe-confirmation">
              <i className="fas fa-check-circle"></i>
              <span>Successfully subscribed!</span>
            </div>
          )}

          {/* Contact Information */}
          <div className="site-footer-contact-details">
            <div className="site-footer-contact-row">
              <i className="fas fa-phone"></i>
              <span>+91 123-456-7890</span>
            </div>
            <div className="site-footer-contact-row">
              <i className="fas fa-envelope"></i>
              <span>support@arbazaar.com</span>
            </div>
            <div className="site-footer-contact-row">
              <i className="fas fa-map-marker-alt"></i>
              <span>Patna, Bihar, India</span>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="site-footer-payment-area">
        <p>Secure Payment Methods</p>
        <div className="site-footer-payment-icons">
          <i className="fab fa-cc-visa"></i>
          <i className="fab fa-cc-mastercard"></i>
          <i className="fab fa-cc-amex"></i>
          <i className="fab fa-cc-discover"></i>
          <i className="fab fa-google-pay"></i>
          <i className="fab fa-apple-pay"></i>
          <i className="fab fa-bitcoin"></i>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="site-footer-bottom-bar">
        <div className="site-footer-bottom-content">
          <p className="site-footer-copyright">
            © 2025 AR-Bazaar. All Rights Reserved | Crafted with <i className="fas fa-heart"></i> in India
          </p>
          <div className="site-footer-bottom-menu">
            <Link to="/privacy">Privacy</Link>
            <span className="site-footer-menu-separator">•</span>
            <Link to="/terms">Terms</Link>
            <span className="site-footer-menu-separator">•</span>
            <Link to="/sitemap">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
